export class NotificationModel {
    public id: number;
    public content: string;
    public status: string;
    public created_at: Date;
    public associated_id: string;
    public associated_type: string;
    constructor(
        id: number,
        content: string,
        status: string,
        created_at: Date,
        associated__id: string,
        associated_type: string
    ) {
        this.id = id;
        this.content = content;
        this.status = status;
        this.created_at = created_at;
        this.associated_id = associated__id;
        this.associated_type = associated_type;
    }
}
